































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { EmailSuggestion } from "@/utils/emailSuggestion";

@Component({ name: "EmailDidYouMean" })
export default class EmailDidYouMean extends Vue {
  @Prop({ default: null }) private suggestion!: EmailSuggestion | null;
  @Prop({ default: "inline" }) private variant!: "inline" | "banner";
  @Prop({ default: false }) private applied!: boolean;
  @Prop({ default: false }) private disabled!: boolean;

  emitApply() {
    if (this.disabled || !this.suggestion) return;
    this.$emit("apply", this.suggestion.suggested);
  }

  emitDismiss() {
    if (this.disabled) return;
    this.$emit("dismiss");
  }
}
